<div
  class="editorContainerWrapper"
>
  <div
    class="editorContainer"
  >
    <h1
      class="headerStyle"
    >
      {{ratingEditorPageHeader()}}
    </h1>
    <app-rating-editor-form></app-rating-editor-form>
    <app-rating-editor-balls-distribution></app-rating-editor-balls-distribution>
    <app-rating-editor-buttons-section></app-rating-editor-buttons-section>
  </div>
</div>
